export default {
    methods: {
        noPrefix(thrust) {
          const noPrefixThrust = ["Artificial Intelligence of Things"]
          if (noPrefixThrust.includes(thrust))
            return true
          return false
        },
        correctThrust(thrust, displayFlag = false){
            // console.log(thrust)
            // since Center for Language Education (GZ) need to be
            // display as Center for Language Education, but need
            // to be evaluated as Center for Language Education (GZ)
            // otherwise is the same as the old Center for Language Education
            // so display flag is needed, and unit availability keeps
            // the (GZ)
            const correctionStoreKeyDisplayValue = {
              "Digital Media and Arts": "Computational Media and Arts",
              "Center for Language Education (GZ)": "Division of Language Education",
              "Institute of Education Innovation and Practice": "Division of General Education",
              "Brain and AI": "Brain and Intelligence",
              "Biomedicine and Biomedical Engineering": "Bioscience and Biomedical Engineering",
              "Earth, Ocean and Atmospheric Science": "Earth, Ocean and Atmospheric Sciences",
              "Innovation, Policy & Entrepreneurship": "Innovation, Policy and Entrepreneurship",
              "Center for Technology Entrepreneurs": "Center for Technology Leadership",
              "Financial Technology (CWB)": "Financial Technology",
            }

            if(displayFlag){
                if (Object.keys(correctionStoreKeyDisplayValue).includes(thrust))
                  return correctionStoreKeyDisplayValue[thrust]
                else
                  return thrust
            }
            else{
                if(thrust === 'Digital Media and Arts'){
                    return 'Computational Media and Arts'
                }
                else{
                    return thrust
                }
            }
        },
    }
}
